// extracted by mini-css-extract-plugin
module.exports = {"application":"styles-module--application--1PmPU","application__screenError":"styles-module--application__screen-error--iZGJS"};